import React, { useState, ChangeEvent } from 'react';

declare var meeApiSettings: any

interface IHttpResponse {
    status: 'success' | 'error',
    errors: string[]
}

interface ICreateTicketRequestData {
    name: string
    email: string
    phone: string
    message: string
    device: string
    subject: string
    priority: string
    customer: string
    serialNumberOrId: string
}

type IAppStatus = 'idle' | 'processing' | 'complete'

const CreateTicket: React.FC = () => {
    const [showForm, setShowForm] = useState(false)
    const [data, setData] = useState<ICreateTicketRequestData>({
        name: '',
        email: '',
        phone: '',
        message: '',
        device: '',
        subject: '',
        priority: '',
        customer: '',
        serialNumberOrId: '',
    })

    const options = [
        'smart pft USB',
        'smart pft CO transfer',
        'smart pft body',
        'smart pft nebulizer',
        'smart pft syringe',
    ]

    const priorities = [
        {id: 1, name: 'Low'},
        {id: 2, name: 'Normal'},
        {id: 3, name: 'High'},
        {id: 4, name: 'Emergency'},
    ]

    const [errors, setErrors] = useState<string[]>([])
    const [status, setStatus] = useState<IAppStatus>('idle')
    
    const handleClick = () => {
        setShowForm(true)
    }

    const handleSubmit = () => {
        setStatus('processing')

        const formData = new FormData()
        for (const key in data) {
            formData.append(key, (data as any)[key])
        }
        
        fetch(meeApiSettings.root + '/tickets', {
            method: 'POST',
            body: formData,
        })
        .then(res => res.json())
        .then((res: IHttpResponse) => {
            if (res.status === 'success') {
                setStatus('complete')
            } else {
                setStatus('idle')
            }
            setErrors(res.errors)
        })
    }

    const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const key = event.target.name as keyof ICreateTicketRequestData
        const value = event.target.value
        const newData = Object.assign({}, data)
        newData[key] = value
        setData(newData)
    }
    
    return (

        <div>
            { status === 'complete' ? 
                <div>
                    <p className="alert alert-success">
                        Thank you for your ticket, we will reach out to you soon. Please check your emails regularly.
                    </p>
                </div>
            :
                <div>
                    { showForm ? (
                        <form>
                            <div className="form-group">
                                <label htmlFor="">Name*</label>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    placeholder="Name" 
                                    value={data.name} 
                                    name="name" 
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="row">
                                <div className="col-md">
                                    <div className="form-group">
                                        <label htmlFor="">Email*</label>
                                        <input type="text" className="form-control" placeholder="Email" value={data.email} name="email" onChange={handleChange}/>
                                    </div>
                                </div>
                                <div className="col-md">
                                    <div className="form-group">
                                        <label htmlFor="">Phone*</label>
                                        <input type="text" className="form-control" placeholder="Phone" value={data.phone} name="phone" onChange={handleChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Product*</label>
                                <select name="device" value={data.device} onChange={handleChange} className="form-control">
                                    <option value="" disabled>Choose ...</option>
                                    { options.map((option, index) => {
                                        return <option key={"option-" + index} value={option}>{option}</option>
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Priority*</label>
                                <select name="priority" value={data.priority} onChange={handleChange} className="form-control">
                                    <option value="" disabled>Choose ...</option>
                                    { priorities.map((priority, index) => {
                                        return <option key={"priority-" + index} value={priority.id}>{priority.name}</option>
                                    })}
                                </select>
                            </div>
                            <div className="row">
                                <div className="col-md">
                                    <div className="form-group">
                                        <label htmlFor="">Customer</label>
                                        <input type="text" className="form-control" placeholder="Customer" value={data.customer} name="customer" onChange={handleChange}/>
                                    </div>
                                </div>
                                <div className="col-md">
                                    <div className="form-group">
                                        <label htmlFor="">Serial number or Id</label>
                                        <input type="text" className="form-control" placeholder="Serial number or Id" value={data.serialNumberOrId} name="serialNumberOrId" onChange={handleChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Subject*</label>
                                <input type="text" className="form-control" placeholder="Subject" value={data.subject} name="subject" onChange={handleChange}/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="">Message*</label>
                                <textarea className="form-control" placeholder="Message" rows={6} value={data.message} name="message" onChange={handleChange}></textarea>
                            </div>
                            { errors.length > 0 ?
                                <p className="alert alert-warning">
                                    { errors.map((error, index) => {
                                        return <span key={'error-' + index}>{error}<br/></span>
                                    })}
                                </p>
                        
                            : undefined}
                            { status === 'processing' ? 
                                <button type="button" disabled className="btn btn-block btn-dark">...</button>
                                :
                                <button type="button" className="btn btn-block btn-dark" onClick={handleSubmit}>Submit ticket</button>
                            }
                        </form>
                    ) : 
                        <button className="btn btn-block btn-dark" onClick={handleClick}>New Ticket</button>
                    }
                </div>
            }
        </div>
    )
}

export default CreateTicket